/// <reference path="../jquery/jquery.d.ts" />

/**
 * This is a generic scroll panel handler. It is based on the scroll panel that can be found on the
 * top of the site, but it is more generic, also it is class based making it reusable
 * *
 * Usage: Panels should be define in html.
 * Every scroller instance must have a container, which is a wrapper for several panels.
 * Theese panels can be scrolled via the public api of the class
 * *
 * Features:
 * - Autoscroll between panels.
 * *
 * Features to do:
 * - Show and hide panels via API
 *
 */

module Sxc {

	export class ActivityWatcher {

		interval: number = null;
		timer: number = 0;
		counter: number = 0;
		resolution: number = 1000; // Min 1 seconds...
		callback: Function;
		resetFn: (e) => any;

		constructor(timer: number, callback: Function) {

			//Increment the idle time counter every timeslice.
			// @ts-ignore
			this.interval = setInterval(() => {this.tick()}, this.resolution);

			this.timer = timer;
			this.callback = callback;

			this.resetFn = (e:JQueryEventObject) => {
				this.counter = 0;
			};

			//Zero the idle timer on mouse movement.
			$(window).on("mousemove", this.resetFn);
			$(window).on("keypress", this.resetFn);
		}

		stop() {

			//Increment the idle time counter every second.
			if (this.interval) {
				clearInterval(this.interval);
				this.interval = null;
			}

			// Remove event handlers
			$(window).off("mousemove", this.resetFn);
			$(window).off("keypress", this.resetFn);
		}

		tick() {
			this.counter += this.resolution;

			if (this.counter >= this.timer) {
				this.counter = 0;
				this.callback();
			}
		}
	}

	class Dots {

		container : JQuery;
		onSelect : Function;
		count = 0;
		selected = -1;

		constructor(container: JQuery, count: number, selected: number, onSelect: Function) {

			this.container = container;
			this.onSelect = onSelect;

			$(this.container).on("click", ".dot", e => {
				var index = parseInt($(e.target).data("id"));
				this.onSelect(index);
			});

			this.setCount(count);
			this.setSelected(selected);
		}

		setCount(n:number) {

			this.count = Math.max(0, n);
			this.container.empty();

			for(var i=0; i<this.count; i++) {
				var dot = $("<div class='dot' />")
					.addClass("dot" + i)
					.appendTo(this.container);
				dot.data("id", i);
				if (i === this.selected)
					dot.addClass("selected");
			}
		}

		setSelected(n:number) {

			this.selected = Math.max(0, Math.min(n, this.count - 1));
			var dots = $(this.container).find(".dot");
			dots.removeClass("selected");
			dots.filter(".dot" + this.selected).addClass("selected");
		}
	}

	class Panel {

		element : JQuery;

		constructor(element) {
			this.element = element;
		}

		getPosition() {
			return this.element.position().left;
		}
	}

	export interface ScrollerParams extends Object {

	}

	export class Scroller {

		private container : JQuery;
		private scroller : JQuery;
		private params : ScrollerParams;
		private panels : Panel[];
		private activeID;
		private dots : Dots;
		private aw: ActivityWatcher;

		constructor(container : JQuery, params : ScrollerParams) {

			this.container = container;
			this.params = params;
			this.init();
		}

		private init() {

			this.panels = [];
			this.scroller = this.container.find('.panels');

			this.container.find('.panels-inner > .panel').each( (i,elem) => {
				this.panels.push(new Panel($(elem)));
			});

			this.activeID = 0;

			var dots = $("<div class='dots' />").appendTo(this.container);
			this.dots = new Dots(dots, this.panels.length, this.activeID, (id) => {
				this.scrollTo(id);
			});

			this.scrollTo(0, true);

			this.aw = new ActivityWatcher(10000, () => {
				var nextPanel = (this.activeID + 1) % this.panels.length;
				this.scrollTo(nextPanel);
			});

		}

		/** Scrolls to a speicific panel. */
		scrollTo(id, fast = false, callback = undefined) {

			if (id < 0 || id >= this.panels.length) return false;

			var panel = this.panels[id];

			// Calculate left position
			var left = panel.getPosition() + this.scroller.scrollLeft();

			if (fast) {
				this.scroller.scrollLeft(left);
			} else {
				this.scroller.animate({scrollLeft: left}, 'slow', 'linear', callback);
			}

			this.activeID = id;
			this.dots.setSelected(id);

			return false;
		}
	}
}
